import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';
import { QrProcessingService } from '@features/auth/services/qr-processing-service';

export const UnauthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const qrFlow = inject(QrProcessingService);

  if (qrFlow.isInQrFlow()) return true;

  if (authService.isAuthenticated()) {
    return router.parseUrl('/');
  }

  if (authService.isGuest()) {
    return true;
  }

  return true;
};
